$(document).ready(function () {
  if ($(".ajax-filter-form").length > 0) {
    var form = $(".ajax-filter-form");
    var url = form.data("url");

    form.find("input, select").change(function (e) {
      e.preventDefault();

      // console.log(form.serialize());

      $.ajax({
        type: "GET",
        url: url,
        data: form.serialize(),
        success: function (response) {
          $(".blog-page__summaries").html(response);
          var newUrl = $(".posts__all").data("url");
          history.pushState(null, null, newUrl);
        },
      });
    });
  }

  $(".blog-page__filter-button").click(function (e) {
    e.preventDefault();
    $(this)
      .toggleClass("open")
      .next(".blog-page__sidebar")
      .toggleClass("active");
  });
});
